/*
 * @Author: Teemo Ding
 * @Date: 2021-10-19 13:52:24
 * @LastEditTime: 2022-06-10 13:37:10
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/MiniProgramBinding/index.tsx
 */
import { Alert, Button, Image } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { InfoCircleOutlined } from '@ant-design/icons';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
const MiniProgramBinding = ({ onBind, unBind, miniProgram, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    uuid = '',
    appId = '',
    accountName = '',
    profileImage = '',
    qrCode = '',
  } = miniProgram || {};

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.logoWrapper}
      title={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramBinding',
      )}>
      {/* //TODO Alert处理（需要字段） */}
      {false && (
        <Alert
          className={css.certificateAlert}
          closable={true}
          message={getI18n(
            'salesChannelMiniProgramSettings.index.noBoundMiniProgram',
          )}
          showIcon
          type='error'
          icon={<Icon type='iconfailed'></Icon>}
          description={getI18n(
            'salesChannelMiniProgramSettings.index.noBoundMiniProgramTip',
          )}
        />
      )}
      {!uuid && (
        <p className={css.bottom}>
          {getI18n(
            'salesChannelMiniProgramSettings.index.noBoundMiniProgramTip2',
          )}
        </p>
      )}
      {uuid && (
        <Fragment>
          <h3>{getI18n('salesChannelMiniProgramSettings.index.appID')}</h3>
          <p className={css.bottom}>{appId}</p>
          <h3>
            {getI18n('salesChannelMiniProgramSettings.index.accountName')}
          </h3>
          <p className={css.bottom}>{accountName}</p>
          <h3>
            {getI18n('salesChannelMiniProgramSettings.index.profileImage')}
          </h3>
          <Image
            src={profileImage}
            key={profileImage}
            className={css.bottom}
            width={80}
            height={80}></Image>
          <h3>
            {getI18n('salesChannelMiniProgramSettings.index.miniProgramQRCode')}
          </h3>
          <Image
            src={qrCode}
            className={css.bottom}
            key={qrCode}
            width={80}
            height={80}></Image>
          <div className={css.icon}>
            <InfoCircleOutlined />{' '}
            {getI18n(
              'salesChannelMiniProgramSettings.index.miniProgramQRCodeTips',
            )}
          </div>
        </Fragment>
      )}

      <Button
        {...(uuid && { danger: true, ghost: true })}
        type='primary'
        onClick={() => (uuid ? unBind() : onBind())}
        disabled={disabled}>
        {uuid
          ? getI18n('salesChannelMiniProgramSettings.index.unbind')
          : getI18n('salesChannelMiniProgramSettings.index.bind')}
      </Button>
    </SectionWrapper>
  );
};

export default MiniProgramBinding;
